var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("label", [
      _vm._v(_vm._s(_vm.resource("IOFormat_Entities_DisplayName")) + " *")
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("multi-select", {
          attrs: {
            name: "SelectedAttributes",
            options: _vm.entities,
            label: "text"
          },
          model: {
            value: _vm.selectedEntities,
            callback: function($$v) {
              _vm.selectedEntities = $$v
            },
            expression: "selectedEntities"
          }
        }),
        _vm._v(" "),
        _vm.showEntitiesError
          ? _c("error-message", {
              attrs: { message: "Please select at least one entity." }
            })
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("label", [
      _vm._v(_vm._s(_vm.resource("IOFormat_Attributes_DisplayName")) + " *")
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _vm._l(_vm.selectedAttributes, function(attribute) {
          return _c("attribute", {
            key: attribute.id,
            ref: "attributes",
            refInFor: true,
            attrs: {
              value: attribute,
              name: attribute.name,
              type: attribute.type,
              attributes: _vm.availableAttributes
            },
            on: {
              "update:name": function($event) {
                return _vm.$set(attribute, "name", $event)
              },
              "update:type": function($event) {
                return _vm.$set(attribute, "type", $event)
              },
              input: function($event) {
                return _vm.setSelectedAttribute($event)
              },
              delete: function($event) {
                return _vm.deleteSelectedAttribute($event)
              }
            }
          })
        }),
        _vm._v(" "),
        _vm.showAttributesError
          ? _c("error-message", {
              attrs: { message: "Please select at least one attribute." }
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "btn btn-outline-secondary",
          attrs: { disabled: _vm.availableAttributes.length === 0 },
          on: { click: _vm.addSelectedAttribute }
        },
        [
          _c("i", { staticClass: "fas fa-plus" }),
          _vm._v(" " + _vm._s(_vm.resource("Button_Add")) + "\n        ")
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }